










































































































































































import { Component, Vue } from 'vue-property-decorator';
import { InvoiceDetailsModule } from '@/store/modules/invoiceDetails';
import GiganautVue from '@/components/Shared/GiganautVue';
import IconConstants from '@/lib/iconConstants';
import InvoiceStatus from '@/models/Invoices/InvoiceStatus';
import UpdateInvoiceStatusRequest from '@/models/Invoices/UpdateInvoiceStatusRequest';

@Component({
	name: 'InvoiceDetails',
  	components: {}
})
export default class extends GiganautVue {

  statusMenu = false;

  get currentInvoice() {
    return InvoiceDetailsModule.currentInvoice;
  }
}
